import { createFileRoute } from "@tanstack/react-router";
import { Deals } from "@/components/Deals";
import { redirect } from "@/lib/navigation";

function RouteComponent() {
  try {
    return <Deals />;
  } catch (error) {
    console.error("Deals page error:", error);
    redirect("/");
  }
}

export const Route = createFileRoute("/_authenticated/deals/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
